// prettier-ignore
const PLACEMENT_MANAGER_EN_US = {
  // TODO: Remove pageHeadings and generate them dynamically similar to breadcrumbs in a follow up PR
  'campaignManagement.placementManager.pageHeadings.list': 'List Placements',
  'campaignManagement.placementManager.pageHeadings.create': 'Create Placement',
  'campaignManagement.placementManager.pageHeadings.edit': 'Edit Placement',
  'campaignManagement.placementManager.pageHeadings.details': 'Placement Details',
  'campaignManagement.placementManager.list.gridHeadings.id': 'ID',
  'campaignManagement.placementManager.list.gridHeadings.rank': 'Rank',
  'campaignManagement.placementManager.list.gridHeadings.status': 'Status',
  'campaignManagement.placementManager.list.gridHeadings.actions': 'Actions',
  'campaignManagement.placementManager.list.gridHeadings.title': 'User facing title',
  'campaignManagement.placementManager.list.gridHeadings.placementType': 'Placement type',
  'campaignManagement.placementManager.list.gridHeadings.noResults': 'No placements to display',
  'campaignManagement.placementManager.list.actionDropdown.details': 'View Placement',
  'campaignManagement.placementManager.list.actionDropdown.edit': 'Edit Placement',
  'campaignManagement.placementManager.list.actionDropdown.rankUp': 'Increase rank',
  'campaignManagement.placementManager.list.actionDropdown.rankDown': 'Decreate rank',
  'campaignManagement.placementManager.list.actionDropdown.delete': 'Disable Placement',
  'campaignManagement.placementManager.breadcrumbs.managerStatus.list': 'List',
  'campaignManagement.placementManager.breadcrumbs.managerStatus.details': 'Details',
  'campaignManagement.placementManager.breadcrumbs.managerStatus.edit': 'Edit',
  'campaignManagement.placementManager.breadcrumbs.managerStatus.create': 'Create',
  'campaignManagement.placementManager.create.selectPlacementType.prompt': 'Select placement Variant',
  'campaignManagement.placementManager.create.sectionHeadings.supportedPlacements': 'Supported Placements',
  'campaignManagement.placementManager.create.footer.discard': 'Discard changes',
  'campaignManagement.placementManager.create.footer.create': 'Publish Placement',
  'campaignManagement.placementManager.create.footer.nextStep': 'Continue',
  'campaignManagement.placementManager.create.footer.previousStep': 'Go back',
  'campaignManagement.placementManager.delete.deleteSuccess': 'Successfully disabled placement',
  'campaignManagement.placementManager.delete.deleteError': 'Error updating placement',
  'campaignManagement.placementManager.delete.delete': 'Delete',
  'campaignManagement.placementManager.delete.confirm.delete.confirmHeader': 'Confirm Placement Disable',
  'campaignManagement.placementManager.delete.confirm.delete.content': 'Are you sure you want to disable this placement? This will immediately hide it from the user experience.',
  'campaignManagement.placementManager.delete.confirm.delete.confirmLabel': 'Delete',
  'campaignManagement.placementManager.delete.confirm.delete.cancelLabel': 'Cancel',
  'campaignManagement.placementManager.update.notify.updateSuccess': 'Placement updated successfully',
  'campaignManagement.placementManager.update.notify.updateError': 'Placement updated failed',
}

const CONTENT_PAGE_BUILDER_EN_US = {
  'campaignManagement.contentPageBuilder.content': 'Content',
  'campaignManagement.contentPageBuilder.pageSettings': 'Page Settings',
  'campaignManagement.contentPageBuilder.addPlacement': 'Add Placement',
  'campaignManagement.contentPageBuilder.removePlacement': 'Remove Placement',
  'campaignManagement.contentPageBuilder.banners': 'Banners',
  'campaignManagement.contentPageBuilder.itemLists': 'Product carousels',
  'campaignManagement.contentPageBuilder.richText': 'Rich Text',
  'campaignManagement.contentPageBuilder.page': 'Page',
  'campaignManagement.contentPageBuilder.pageStatus.draft': 'Draft',
  'campaignManagement.contentPageBuilder.pageStatus.active': 'Active',
  'campaignManagement.contentPageBuilder.preview': 'Preview',
  'campaignManagement.contentPageBuilder.publish': 'Publish',
  'campaignManagement.contentPageBuilder.publishing': 'Publishing',
  'campaignManagement.contentPageBuilder.saveAsDraft': 'Save As Draft',
  'campaignManagement.contentPageBuilder.createPageToSave':
    'Finish entering required page settings to save the page.',
  'campaignManagement.contentPageBuilder.saving': 'Saving Changes',
  'campaignManagement.contentPageBuilder.changesSaved': 'Changed Saved',
  'campaignManagement.contentPageBuilder.pageSettings.heading': 'Page Details',
  'campaignManagement.contentPageBuilder.pageSettings.name': 'Name',
  'campaignManagement.contentPageBuilder.pageSettings.slug': 'Slug',
  'campaignManagement.contentPageBuilder.pageSettings.slugValidation':
    'Only alphanumeric, underscore, and dash characters are allowed in a page slug.',
  'campaignManagement.contentPageBuilder.pageSettings.requiredField': 'Required',
  'campaignManagement.contentPageBuilder.pageSettings.preCreateInformationHeading': 'Get Started',
  'campaignManagement.contentPageBuilder.pageSettings.preCreateInformationBody':
    'Give your page a name and a slug to start editing your site.',
  'campaignManagement.contentPageBuilder.placementPicker.banners': 'Banners',
  'campaignManagement.contentPageBuilder.placementPicker.itemLists': 'Product carousels',
  'campaignManagement.contentPageBuilder.placementPicker.standardProductCarousel':
    'Standard Product Carousel',
  'campaignManagement.contentPageBuilder.placementPicker.heroBannerCarousel':
    'Primary Banner Carousel',
  'campaignManagement.contentPageBuilder.placementPicker.secondaryBannerCarousel':
    'Secondary Single Banner Carousel',
  'campaignManagement.contentPageBuilder.placementPicker.secondaryBannerCarouselSplit':
    'Secondary Split Banner Carousel',
  'campaignManagement.contentPageBuilder.placementPicker.richTextGroupLabel': 'Text Container',
  'campaignManagement.contentPageBuilder.placementPicker.richTextLabel': 'Text Container',
  'campaignManagement.contentPageBuilder.placementPicker.globalGroupLabel': 'Global',
  'campaignManagement.contentPageBuilder.placementPicker.announcementBannerLabel':
    'Announcement Banner',
  'campaignManagement.contentPageBuilder.heroBannerCarouselLabel': 'Banner • Hero',
  'campaignManagement.contentPageBuilder.secondaryBannerCarouselLabel': 'Banner • Secondary Single',
  'campaignManagement.contentPageBuilder.secondaryBannerCarouselSplitLabel':
    'Banner • Secondary Split',
  'campaignManagement.contentPageBuilder.globalLabel': 'Global',
  'campaignManagement.contentPageBuilder.itemListLabel': 'Product Carousel • Standard',
  'campaignManagement.contentPageBuilder.bannerLabel': 'Banner',
  'campaignManagement.contentPageBuilder.richTextLabel': 'Rich Text Container',
  'campaignManagement.contentPageBuilder.notifications.publishSuccess': 'Draft version published.',
  'campaignManagement.contentPageBuilder.notifications.publishFailure':
    'An error occurred while publishing the draft version.',
  'campaignManagement.contentPageBuilder.notifications.createPageSuccess':
    'New page created, now editing a draft.',
  'campaignManagement.contentPageBuilder.notifications.createPageFailure':
    'An error occurred while creating a new page.',
  'campaignManagement.contentPageBuilder.notifications.deletePlacementSuccess':
    'Deleted placement.',
  'campaignManagement.contentPageBuilder.notifications.deletePlacementFailure':
    'An error occurred while deleting placement.',
  'campaignManagement.contentPageBuilder.notifications.updateRankingsSuccess':
    'Updated placement rankings.',
  'campaignManagement.contentPageBuilder.notifications.updateRankingsFailure':
    'An error occurred while updating placement rankings.',
  'campaignManagement.contentPageBuilder.notifications.loadPageFailure':
    'An error occurred while fetching the page and placements.',
  'campaignManagement.contentPageBuilder.removeBtn.removePlacementConfirmationTitle':
    'Remove placement',
  'campaignManagement.contentPageBuilder.removeBtn.removePlacementConfirmationBody':
    'Are you sure you want to remove this placement?',
  'campaignManagement.contentPageBuilder.removeBtn.automaticBannersRemovalNote':
    'By removing this placement, all banners within it will be removed as well.',
  'campaignManagement.contentPageBuilder.removeBtn.removeBannerConfirmationTitle': 'Remove banner',
  'campaignManagement.contentPageBuilder.removeBtn.removeBannerConfirmationBody':
    'Are you sure you want to remove this banner?',
  'campaignManagement.contentPageBuilder.removeBtn.automaticCarouselRemovalNote':
    'By removing this banner, the entire banner carousel will be removed as well.',
}

const CONTENT_PAGE_BUILDER_BANNER_CAROUSEL_ORDER_PREVIEW_EN_US = {
  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.primaryBanner.heading':
    'Banner • Hero',
  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.secondaryBanner.heading':
    'Banner • Secondary Single',
  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.secondaryBannerSplit.heading':
    'Banner • Secondary Split',
  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.primaryBanner.placementFormHeading':
    'Banner • Hero / Banner',
  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.secondaryBanner.placementFormHeading':
    'Banner • Secondary Single / Banner',
  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.secondaryBannerSplit.placementFormHeading':
    'Banner • Secondary Split / Banner',
  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.addBannerButton': 'Add banner',

  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.existingBannersHeading':
    'Existing Banners',
  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.bannerIndex': 'Banner',
  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.duration': 'Duration:',
  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.ongoing': 'Ongoing',
  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.noStartDate': 'No Start Date',
  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.noEndDate': 'No End Date',
  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.createdBy': 'Created by',
  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.editBannerButton':
    'Edit banner',
  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.variantSelector.imageTextBtn':
    'Image, Text, Button',
  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.variantSelector.imageOnly':
    'Image Only',
  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.secondaryBannerSplit.alertTitle':
    'Avoid empty space',
  'campaignManagement.contentPageBuilder.bannerCarouselOrderPreview.secondaryBannerSplit.alertMsg':
    'With split banners, upload two at a time to avoid wasted space on your page.',
}

const CONTENT_PAGE_BUILDER_ANNOUNCEMENT_BANNER_EN_US = {
  'campaignManagement.contentPageBuilder.announcementBannerForm.show': 'Show',
  'campaignManagement.contentPageBuilder.announcementBannerForm.hide': 'Hide',
  'campaignManagement.contentPageBuilder.announcementBannerForm.heading': 'Announcement Banner',
  'campaignManagement.contentPageBuilder.announcementBannerForm.removePlacementLabel':
    'Remove Placement',
  'campaignManagement.contentPageBuilder.announcementBannerForm.savePlacementLabel':
    'Save Placement',
  'campaignManagement.contentPageBuilder.announcementBannerForm.globalPlacement':
    'Global Placement',
  'campaignManagement.contentPageBuilder.announcementBannerForm.alertMsg':
    'Announcement banners are global placements. This means they will persist above the header in all pages of your storefront.',
  'campaignManagement.contentPageBuilder.announcementBannerForm.uploadVariant.image': 'Image',
  'campaignManagement.contentPageBuilder.announcementBannerForm.uploadVariant.altText': 'Alt Text',
  'campaignManagement.contentPageBuilder.announcementBannerForm.uploadVariantTitle':
    'Image or Icon',
  'campaignManagement.contentPageBuilder.announcementBannerForm.uploadVariant.icon': 'Icon',
  'campaignManagement.contentPageBuilder.announcementBannerForm.uploadVariant.largeScreen':
    'Large Screen (8:1)',
  'campaignManagement.contentPageBuilder.announcementBannerForm.uploadVariant.largeScreen.tips':
    'For desktops and laptops',
  'campaignManagement.contentPageBuilder.announcementBannerForm.uploadVariant.smallScreen':
    'Small Screen (4:1)',
  'campaignManagement.contentPageBuilder.announcementBannerForm.uploadVariant.smallScreen.tips':
    'For common phones and tablets',
  'campaignManagement.contentPageBuilder.announcementBannerForm.uploadVariant.recommendedSize':
    'Recommended image resolution:',
  'campaignManagement.contentPageBuilder.announcementBannerForm.uploadVariant.desktopSize':
    '120 px by 48 px',
  'campaignManagement.contentPageBuilder.announcementBannerForm.uploadVariant.mobileSize':
    '72 px by 28 px',
  'campaignManagement.contentPageBuilder.announcementBannerForm.title': 'Title',
  'campaignManagement.contentPageBuilder.announcementBannerForm.headerText': 'Header Text',
  'campaignManagement.contentPageBuilder.announcementBannerForm.headerTextColor':
    'Header Text Color',
  'campaignManagement.contentPageBuilder.announcementBannerForm.titleInfo':
    'Recommended character limit: 60',
  'campaignManagement.contentPageBuilder.announcementBannerForm.button': 'Button',
  'campaignManagement.contentPageBuilder.announcementBannerForm.labelText': 'Label Text',
  'campaignManagement.contentPageBuilder.announcementBannerForm.labelInfo':
    'Recommended character limit: 10',
  'campaignManagement.contentPageBuilder.announcementBannerForm.buttonColor': 'Button Color',
  'campaignManagement.contentPageBuilder.announcementBannerForm.buttonTextColor':
    'Button Text Color',
  'campaignManagement.contentPageBuilder.announcementBannerForm.destination': 'Destination',
  'campaignManagement.contentPageBuilder.announcementBannerForm.destinationTitle': 'URL',
  'campaignManagement.contentPageBuilder.announcementBannerForm.destinationType':
    'Destination Type',
  'campaignManagement.contentPageBuilder.announcementBannerForm.destinationPlaceholder':
    'Enter URL',
  'campaignManagement.contentPageBuilder.announcementBannerForm.openInSameTab':
    'Open URL in Same Tab',
  'campaignManagement.contentPageBuilder.announcementBannerForm.openInNewTab':
    'Open URL in New Tab',
  'campaignManagement.contentPageBuilder.announcementBannerForm.openInNewWindow':
    'Open URL in New Window',
  'campaignManagement.contentPageBuilder.announcementBannerForm.backgroundColor':
    'Background Color',
  'campaignManagement.contentPageBuilder.announcementBannerForm.closeButton': 'Close Button',
  'campaignManagement.contentPageBuilder.announcementBannerForm.dismissButtonColor':
    'Dismiss Button Color',
  'campaignManagement.contentPageBuilder.announcementBannerForm.localization': 'Localization',
  'campaignManagement.contentPageBuilder.announcementBannerForm.addLocale': 'Add Locale',
  'campaignManagement.contentPageBuilder.announcementBannerForm.noLocalesAdded': 'No Locales Added',
  'campaignManagement.contentPageBuilder.announcementBannerForm.notify.placementSaved':
    'Placement Saved',
  'campaignManagement.contentPageBuilder.announcementBannerForm.notify.placementDeleted':
    'Placement Deleted',
  'campaignManagement.contentPageBuilder.announcementBannerForm.notify.placementSavedFail':
    'Failed to save the placement',
  'campaignManagement.contentPageBuilder.announcementBannerForm.notify.placementDeletedFail':
    'Failed to delete the placement',
  'campaignManagement.contentPageBuilder.announcementBannerForm.custom': 'Custom',
  'campaignManagement.contentPageBuilder.announcementBannerForm.customColorInput':
    'Custom Color Input',
}

const CONTENT_PAGE_BUILDER_RICH_TEXT_EDITOR = {
  'campaignManagement.contentPageBuilder.richTextEditor.heading': 'Text Container',
  'campaignManagement.contentPageBuilder.richTextEditor.placeholderText': 'Enter some text...',
  'campaignManagement.contentPageBuilder.richTextEditor.toolbar.paragraph': 'Paragraph',
  'campaignManagement.contentPageBuilder.richTextEditor.toolbar.heading1': 'Heading 1',
  'campaignManagement.contentPageBuilder.richTextEditor.toolbar.heading2': 'Heading 2',
  'campaignManagement.contentPageBuilder.richTextEditor.toolbar.heading3': 'Heading 3',
  'campaignManagement.contentPageBuilder.richTextEditor.toolbar.bulletList': 'Bulleted List',
  'campaignManagement.contentPageBuilder.richTextEditor.toolbar.numberList': 'Numbered List',
  'campaignManagement.contentPageBuilder.richTextEditor.toolbar.strikethrough': 'Strikethrough',
}

const HOME_PAGE_EN_US = {
  'campaignManagement.themePages.homepage.title': 'Homepage Manager',
}

const PLACEMENT_TOOLING_EN_US = {
  'campaignManagement.placementTooling.destination.createNewCollection': 'Create a new collection',
  'campaignManagement.placementTooling.placementSaveSuccess': 'Changes saved.',
  'campaignManagement.placementTooling.placementSaveFailed':
    'There was an error while saving changes to the placement.',
  'campaignManagement.placementTooling.save': 'Save',
  'campaignManagement.placementTooling.itemListPlacementForm.heading':
    'Product Carousel • Standard',
  'campaignManagement.placementTooling.itemListPlacementForm.selectACollection':
    'Select a collection',
  'campaignManagement.placementTooling.themeColor.black': 'Black',
  'campaignManagement.placementTooling.themeColor.white': 'White',
  'campaignManagement.placementTooling.themeColor.brandPrimaryRegular': 'Primary Regular',
  'campaignManagement.placementTooling.themeColor.brandPrimaryDark': 'Primary Dark',
  'campaignManagement.placementTooling.themeColor.brandSecondaryRegular': 'Secondary Regular',
  'campaignManagement.placementTooling.themeColor.brandSecondaryLight': 'Secondary Light',
  'campaignManagement.placementTooling.themeColor.brandSecondaryDark': 'Secondary Dark',
  'campaignManagement.placementTooling.themeColor.brandHighlightRegular': 'Highlight Regular',
  'campaignManagement.placementTooling.themeColor.brandHighlightLight': 'Highlight Light',
  'campaignManagement.placementTooling.themeColor.brandHighlightDark': 'Highlight Dark',
  'campaignManagement.placementTooling.themeColor.brandPromotionalRegular': 'Promotional Regular',
  'campaignManagement.placementTooling.themeColor.brandPromotionalLight': 'Promotional Light',
  'campaignManagement.placementTooling.themeColor.brandPromotionalDark': 'Promotional Dark',
  'campaignManagement.placementTooling.themeColor.brandLoyaltyRegular': 'Loyalty Regular',
  'campaignManagement.placementTooling.themeColor.brandLoyaltyLight': 'Loyalty Light',
  'campaignManagement.placementTooling.themeColor.brandLoyaltyDark': 'Loyalty Dark',
}

const EN_US = {
  'campaignManagementDomain.title': 'Campaign Management',
  'campaignManagement.themePages.listPage.title': 'Theme Page Manager',
  'campaignManagement.themePages.listPage.noResults': 'No Theme Pages to show',
  'campaignManagement.themePages.listPage.createButton': 'Create Theme Page',
  'campaignManagement.themePages.listPage.itemMenu.edit': 'Edit Theme Page',
  'campaignManagement.themePages.listPage.itemMenu.delete': 'Delete Theme Page',
  'campaignManagement.themePages.listPage.itemMenu.addItemLists': 'Manage Placements',
  'campaignManagement.themePages.detailsPage.title': 'Theme Page Details',
  'campaignManagement.themePages.createPage.title': 'Create Theme Page',
  'campaignManagement.themePages.editPage.title': 'Edit Theme Page',
  'campaignManagement.themePages.columns.slug.header': 'Slug',
  'campaignManagement.themePages.columns.active.header': 'Active',
  'campaignManagement.themePages.columns.createdAt.header': 'Created At',
  'campaignManagement.themePages.columns.actions.header': 'Actions',
  'campaignManagement.themePages.status.active': 'True',
  'campaignManagement.themePages.status.inactive': 'False',
  'campaignManagement.themePages.status.active.definition': 'Theme page placement is enabled',
  'campaignManagement.themePages.status.inactive.definition': 'Theme page placement is disabled',
  'campaignManagement.themePages.details.placementSection.title': 'Placement Content',
  'campaignManagement.themePages.details.placementSection.id': 'Theme page id',
  'campaignManagement.themePages.details.placementSection.slug': 'Slug',
  'campaignManagement.themePages.details.headerSection.title': 'Header Content',
  'campaignManagement.themePages.details.headerSection.bannerId': 'Banner Id',
  'campaignManagement.themePages.details.headerSection.placementId': 'Placement Id',
  'campaignManagement.themePages.details.headerSection.bannerTitle': 'Banner Title',
  'campaignManagement.themePages.details.headerSection.titleColorHex': 'Title Color Hex',
  'campaignManagement.themePages.details.headerSection.subTitle': 'Banner Sub-Title',
  'campaignManagement.themePages.details.headerSection.subTitleColorHex': 'Sub Title Color Hex',
  'campaignManagement.themePages.details.headerSection.showRetailerPicker': 'Show Retailer Picker',
  'campaignManagement.themePages.details.headerSection.showSearchBar': 'Show Search Bar',
  'campaignManagement.themePages.details.headerSection.createdAt': 'Created At',
  'campaignManagement.themePages.details.headerSection.updatedAt': 'Updated At',
  'campaignManagement.themePages.details.imageSection.title': 'Banner Image',
  'campaignManagement.themePages.details.imageSection.imageDesktop': 'Desktop Image',
  'campaignManagement.themePages.details.imageSection.imageMobile': 'Mobile Image',
  'campaignManagement.themePages.details.imageSection.imageAltText': 'Image Alt Text',
  'campaignManagement.themePages.details.imageSection.backgroundColorHex': 'Background Color Hex',
  'campaignManagement.themePages.details.imageSection.disclaimerUrl': 'Disclaimer URL',
  'campaignManagement.themePages.create.mainSectionTitle': 'Theme Page Details',
  'campaignManagement.themePages.create.imageSectionTitle': 'Banner Image',
  'campaignManagement.themePages.create.slugLabel': 'Slug',
  'campaignManagement.themePages.create.bannerTitle': 'Banner Title',
  'campaignManagement.themePages.create.titleColorHex': 'Title Color Hex',
  'campaignManagement.themePages.create.backgroundColorHex': 'Background Color Hex',
  'campaignManagement.themePages.create.showSearchbar': 'Show Search Bar',
  'campaignManagement.themePages.create.showRetailerPicker': 'Show Retailer Picker',
  'campaignManagement.themePages.create.subTitle': 'Banner Sub-Title',
  'campaignManagement.themePages.create.subTitleColorHex': 'Sub-Title Color Hex',
  'campaignManagement.themePages.create.desktopImage': 'Desktop Image',
  'campaignManagement.themePages.create.mobileImage': 'Mobile Image',
  'campaignManagement.themePages.create.imageAltText': 'Image Alt Text',
  'campaignManagement.themePages.create.disclaimerUrl': 'Disclaimer URL',
  'campaignManagement.themePages.create.submitCreate': 'Create',
  'campaignManagement.themePages.create.submitUpdate': 'Update',
  'campaignManagement.themePages.create.submitCancel': 'Cancel',
  'campaignManagement.themePages.create.placeholder.slug': 'theme_page_slug',
  'campaignManagement.themePages.create.placeholder.title': 'Theme Page Title',
  'campaignManagement.themePages.create.placeholder.subTitle':
    'This is the subtitle of the theme page that will be displayed on the header section',
  'campaignManagement.themePages.create.placeholder.imageAltText': 'Text describing the image',
  'campaignManagement.themePages.create.placeholder.disclaimerUrl':
    'CTA link attached to heading banner to direct customers to a disclaimer page',
  'campaignManagement.themePages.update.updateSuccess': 'Theme page updated successfully',
  'campaignManagement.themePages.update.updateFailed': 'Failed to update',
  'campaignManagement.themePages.create.createSuccess': 'Theme page created successfully',
  'campaignManagement.themePages.create.createFailed': 'Failed to create',
  'campaignManagement.themePages.create.slug.validation':
    'Slug can only contain lowercase alphabets, numbers, and underscores',
  'campaignManagement.themePages.notApplicable': 'N/A',
  'campaignManagement.themePages.fieldRequired': 'This field is required',
  ...PLACEMENT_MANAGER_EN_US,
  ...HOME_PAGE_EN_US,
  ...PLACEMENT_MANAGER_EN_US,
  ...CONTENT_PAGE_BUILDER_EN_US,
  ...PLACEMENT_TOOLING_EN_US,
  ...CONTENT_PAGE_BUILDER_BANNER_CAROUSEL_ORDER_PREVIEW_EN_US,
  ...CONTENT_PAGE_BUILDER_ANNOUNCEMENT_BANNER_EN_US,
  ...CONTENT_PAGE_BUILDER_RICH_TEXT_EDITOR,
} as const

export default EN_US
